import React, { useMemo, useState } from "react";
import LayoutAdmin from "../../components/layouts/LayoutAdmin";
import {FaIcons, BsIcons, MdIcons} from "../../icons/export-reacticons";
import DataTable from 'react-data-table-component';
import LoaderSmall from "../../components/Loaders/LoaderSmall";
import HeaderSearchTable from "../../components/Custom/HeaderSearchTable";
import { useMutateToggleDeleteEnVivo, useMutateTogglePublishEnVivo, useQueryLivesEnVivo } from "../../hooks/lives.hooks";
import { getDateTimeObject } from "../../utils/dateTime";
import { SwalToast } from "../../utils/toasts";
import Swal from "sweetalert2";
import { NavLink } from "react-router-dom";

const dayJs = getDateTimeObject();

const ListarEnVivos = () => {
    
    const [filterText, setFilterText] = useState("");
	const [resetPagination, setResetPagination] = useState(false);
	const [filteredItems, setFilteredItems] = useState([]);
    const [showModalCreate, setShowModalCreate] = useState(false);
	const [showModalEdit, setShowModalEdit] = useState(false);
    const [idLive, setIdLive] = useState(null);
	
	//React Query Hooks
    const { data:livesList, isLoading } = useQueryLivesEnVivo();
    const { mutate: togglePublish } = useMutateTogglePublishEnVivo();
	const { mutate: toggleDelete } = useMutateToggleDeleteEnVivo();
	
	const handleSendToEdit = (idLive) => {
		setIdLive(idLive);
		setShowModalEdit(true);
	}
	
	const handleCopyToClipboard = (text) => {
		navigator.clipboard.writeText(process.env.REACT_APP_API_CLIENT+'lives/'+text).then(() => {
			SwalToast.fire({
				title: "Copiado al portapapeles",
				icon: "success",
				timer: 1500,
			})
		})
		.catch(err => {
			SwalToast.fire({
				title: "Error al copiar al portapapeles",
				icon: "error",
				timer: 1500,
			})
		});
	}
	
	const handleTogglePublish = (idLive, status) => {
		Swal.fire({
			title: "¿Estás seguro?",
			text: "¿Deseas cambiar el estado del live?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Si, cambiar",
			cancelButtonText: "Cancelar",
		}).then((result) => {
			if(result.isConfirmed){
				togglePublish({
					idLive,
					status,
				}, {
					onSuccess: () => {
						SwalToast.fire({
							icon: "success",
							title: "El live se ha actualizado correctamente",
						});
					},
					onError: (error) => {
						SwalToast.fire({
							icon: "error",
							title: "Error al actualizar el live",
						});
					}
				});
			}
		})
	}
	
	const handleToggleDelete = (idLive, status) => {
		Swal.fire({
			title: "¿Estás seguro?",
			text: "¿Deseas cambiar el estado del live?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Si, cambiar",
			cancelButtonText: "Cancelar",
		}).then((result) => {
			if(result.isConfirmed){
				toggleDelete({
					idLive,
					status,
				}, {
					onSuccess: () => {
						SwalToast.fire({
							icon: "success",
							title: "El live se ha actualizado correctamente",
						});
					},
					onError: (error) => {
						SwalToast.fire({
							icon: "error",
							title: "Error al actualizar el live",
						});
					}
				});
			}
		})
	}
	
    /* Search Component */
	const searchComponentMemo = useMemo(() => {
		return (
			<HeaderSearchTable
				filterText={filterText}
				setFilterText={setFilterText}
				arrayData={livesList}
				setArrayFiltered={setFilteredItems}
				setResetPagination={setResetPagination}
				placeholder="Buscar por nombre"
				columnsToFilter={["nombre_live"]}
			/>
		);
	}, [filterText, resetPagination]);
    
    /* Config Table */
	const columns = useMemo(
		() => [
			{
				name: '#',
				cell: (row) => row.id_live_publico,
				width: '5%',
			},
			{
				name: "Url Vivo",
                width: '250px',
				selector: (row) => row.url_envivo,
				sortable: true,
			},

			{
				name: "Activar",
				width: "7%",
				cell: (row) => (
					<>
						{
							parseInt(row.activo) === 0 ? (
								<button
									className="btn btn-sm mx-1"
									type="button"
									title="Activar"
									onClick={() => handleTogglePublish(row.id_live_publico, 1)}
								>
											<BsIcons.BsToggleOff color="#ff0000" size={20} />
								</button>
							):(
								<button
									className="btn btn-sm mx-1"
									type="button"
									title="Desactivar"
									onClick={() => handleTogglePublish(row.id_live_publico, 0)}
								>
							
									<BsIcons.BsToggleOn color="#37af48" size={20} />
								</button>
							)
						}
					</>
				)
			},
			{
				name: "Acciones",
				cell: (row) => (
						<div className="d-flex">
								<NavLink  to={`/lives/editar-envivo/${row.cod_unico}`}
							className="btn ge-btn-primary btn-sm mr-2"
								>
									<FaIcons.FaEdit />
								</NavLink>
							{
								parseInt(row.eliminado) === 0 ? (
									<button 
										className="btn btn-danger text-light btn-sm mx-1"
										title="Eliminar"
										onClick={() => handleToggleDelete(row.id_live_publico, 1)}
									>
										<FaIcons.FaTrashAlt size={15} />
									</button>
								):(
									<button 
										className="btn btn-success btn-sm mx-1"
										title="Restaurar"
										onClick={() => handleToggleDelete(row.id_live_publico, 0)}
										>
										<FaIcons.FaTrashRestoreAlt size={15} />
									</button>
								)
							}
						</div>
					),
			},

		],
		[]
	);
    
	return (
		<LayoutAdmin contentTitle="" routeTitle="Lista de docentes">
			<div className="row">
				<div className="col-12">
					<div className="card p-2">
						<div className="d-flex justify-content-between card-header card-no-after ge-noborder">
							<div>
								<img
									src="/images/file-icon.png"
									className="mr-2"
									style={{ width: "40px" }}
									alt="file-icon"
								/>
								<span className="ge-h3 ge-title">
									Lista de lives
								</span>
							</div>
						</div>
						<div className="card-body">
							<DataTable
								className="custom-datatable"
								columns={columns}
								data={
									filteredItems.length > 0
										? filteredItems
										: livesList
								}
								subHeader
								subHeaderComponent={searchComponentMemo}
								pagination
								responsive
								progressPending={isLoading}
								progressComponent={<LoaderSmall />}
							/>
						</div>
					</div>
				</div>
			</div>
		</LayoutAdmin>
	);
};

export default ListarEnVivos;
